import { useEffect, useState } from "react";
import fallbackData from "./alt-redirect.json";
import { getEnvironment } from "shared/utils/getEnvironment";
import { captureSentryException } from "../sentry/captureException";

export const getAltRedirectS3 = (): string => {
  const environmentType = getEnvironment();

  if (environmentType === "production") {
    return "https://s3.us-east-1.amazonaws.com/ads.voopter/production/alt_redirect/alt_redirect.json";
  }

  return "https://s3.us-east-1.amazonaws.com/ads.voopter/staging/alt_redirect/alt_redirect.json";
};

const S3_JSON_URL = getAltRedirectS3();

export function useAltRedirectHook<T>() {
  const [altRedirectCampaign, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(S3_JSON_URL, {
          mode: "cors",
          headers: {
            Accept: "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        });
        // `JSON.stringify(response)` dava sempre `{}`: sem status o Sentry
        // agrupava 403 e 500 como o mesmo erro sem pista.
        if (!response.ok)
          throw new Error(
            `Erro ao carregar alt-redirect: HTTP ${response.status}`,
          );

        const jsonData: T = await response.json();
        setData(jsonData);
        console.log("alt-redirect lido com sucesso");
      } catch (err) {
        captureSentryException(err, {
          tags: {
            feature: "alt-redirect",
            operation: "fetchAltRedirectConfig",
          },
          contexts: {
            request: {
              url: S3_JSON_URL,
            },
          },
        });
        console.error(
          "Erro ao ler o alt-redirect.json do S3. Nenhuma campanha será executada -> " +
            S3_JSON_URL,
          err,
        );
        setData(fallbackData as T);
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return { altRedirectCampaign, loading, error };
}
